/**
 * 双色图片选择
 * @type {*[]}
 */
let menulist = [
  {
    selected: require('../assets/finance/ic_shuaxin_checked@2x.png'),
    unselected: require('../assets/finance/ic_shuaxin@2x.png')
  }, {
    selected: require('../assets/finance/ic_fuzhi_checked@2x.png'),
    unselected: require('../assets/finance/ic_fuzhi@2x.png')
  }, {
    selected: require('../assets/finance/ic_kaidan_checked@2x.png'),
    unselected: require('../assets/finance/ic_kaidan@2x.png')
  }, {
    selected: require('../assets/finance/ic_shanchu_checked@2x.png'),
    unselected: require('../assets/finance/ic_shanchu@2x.png')
  }, {
    selected: require('../assets/finance/ic_shanxuan_checked@2x.png'),
    unselected: require('../assets/finance/ic_shanxuan@2x.png')
  }, {
    selected: require('../assets/finance/ic_daochu_checked@2x.png'),
    unselected: require('../assets/finance/ic_daochu@2x.png')
  }, {
    selected: require('../assets/finance/ic_yulan_checked@2x.png'),
    unselected: require('../assets/finance/ic_yulan@2x.png')
  }, {
    selected: require('../assets/finance/ic_qr_checked@2x.png'),
    unselected: require('../assets/finance/ic_qr @2x.png')
  }, {
    selected: require('../assets/finance/ic_xinjian_checked@2x.png'),
    unselected: require('../assets/finance/ic_xinjian@2x.png')
  }, {
    selected: require('../assets/finance/ic_tongji_checked@2x.png'),
    unselected: require('../assets/finance/ic_tongji@2x.png')
  }, {
    selected: require('../assets/order/ic_xiaoshou_checked@2x.png'),
    unselected: require('../assets/order/ic_xiaoshou@2x.png')
  }, {
    selected: require('../assets/order/ic_yushou_checked@2x.png'),
    unselected: require('../assets/order/ic_yushou@2x.png')
  }, {
    selected: require('../assets/order/ic_tuihuo_checked@2x.png'),
    unselected: require('../assets/order/ic_tuihuo@2x.png')
  }, {
    selected: require('../assets/order/ic_pandian_checked@2x.png'),
    unselected: require('../assets/order/ic_pandian@2x.png')
  }, {
    selected: require('../assets/finance/ic_bianji_checked@2x.png'),
    unselected: require('../assets/finance/ic_bianji@2x.png')
  }, {
    selected: require('../assets/finance/ic_baocun_checked@2x.png'),
    unselected: require('../assets/finance/ic_baocun@2x.png')
  }, {
    selected: require('../assets/finance/ic_paixu_checked@2x.png'),
    unselected: require('../assets/finance/ic_paixu@2x.png')
  }, {
    selected: require('../assets/finance/ic_xiugai_checked@2x.png'),
    unselected: require('../assets/finance/ic_xiugai@2x.png')
  }, {
    selected: require('../assets/finance/ic_shangjia_checked@2x.png'),
    unselected: require('../assets/finance/ic_shangjia@2x.png')
  }, {
    selected: require('../assets/finance/ic_xiajia_checked@2x.png'),
    unselected: require('../assets/finance/ic_xiajia@2x.png')
  }, {
    selected: require('../assets/finance/ic_shenhe_checked@2x.png'),
    unselected: require('../assets/finance/ic_shenhe@2x.png')
  }, {
    selected: require('../assets/finance/ic_shangyi_checked@2x.png'),
    unselected: require('../assets/finance/ic_shangyi@2x.png')
  }, {
    selected: require('../assets/finance/ic_xiayi_checked@2x.png'),
    unselected: require('../assets/finance/ic_xiayi@2x.png')
  }, {
    selected: require('../assets/finance/ic_qianyi_checked@2x.png'),
    unselected: require('../assets/finance/ic_qianyi@2x.png')
  }, {
    selected: require('../assets/finance/ic_fanhui_checked@2x.png'),
    unselected: require('../assets/finance/ic_fanhui@2x.png')
  }, {
    selected: require('../assets/common/ic_shenpitongguo_checked@2x.png'),
    unselected: require('../assets/common/ic_shenpitongguo@2x.png')
  }, {
    selected: require('../assets/common/ic_shenpijujue_checked.png'),
    unselected: require('../assets/common/ic_shenpijujue.png')
  }]


export const getMenuPic = (index) => {
  return menulist[index]
}
